"use client";

import {
  createContext,
  type ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";
import { twMerge } from "tailwind-merge";
import { AppError } from "@/errors";

type LayoutSlotContextValue = {
  rightActions: ReactNode | null;
  setRightActions: (node: ReactNode | null) => void;
};

const LayoutSlotContext = createContext<LayoutSlotContextValue | null>(null);

export function LayoutSlotProvider({ children }: { children: ReactNode }) {
  const [rightActions, setRightActions] = useState<ReactNode | null>(null);
  const value = useMemo(
    () => ({ rightActions, setRightActions }),
    [rightActions],
  );

  return (
    <LayoutSlotContext.Provider value={value}>
      {children}
    </LayoutSlotContext.Provider>
  );
}

export function useLayoutRightActions() {
  const ctx = useContext(LayoutSlotContext);
  if (!ctx)
    throw new AppError(
      "LAYOUT_SLOT_CTX_MISSING",
      "useLayoutRightActions must be used within LayoutSlotProvider",
    );

  return ctx;
}

export function NavbarRightActionsSlot({ className }: { className?: string }) {
  const { rightActions } = useLayoutRightActions();

  return (
    <div
      className={twMerge(
        "min-h-11 sm:min-h-9 flex items-center justify-end",
        className,
      )}
    >
      {rightActions}
    </div>
  );
}
